import { API_CLIENT } from "../api_call/service_instances.js";

import {
	GET_STREET,
	GET_BICYCYLES,
	MARKERS_MAP_DATA_CCTV,
	PUBLIC_TRANSPORT_URBAN,
	GET_NOTIFICATIONS_LIST,
	ROUTES_DATA_MAP_TRAFFIC,
	PUBLIC_TRANSPORT_INTERURBAN,
	GET_TAXI
} from "../url/urls_in_app.js";

/*
 * --------------------------------------------------------
 *  Contain all url and fuctions needed to make call to the application
 *  only for transport part
 * --------------------------------------------------------
 */

export default {
	getRoutesData() {
		return API_CLIENT(ROUTES_DATA_MAP_TRAFFIC);
	},

	getMarkers() {
		return API_CLIENT(MARKERS_MAP_DATA_CCTV);
	},

	getPublicTransport() {
		return API_CLIENT(PUBLIC_TRANSPORT_URBAN);
	},

	getPublicTransportInterurban() {
		return API_CLIENT(PUBLIC_TRANSPORT_INTERURBAN);
	},

	getBicycles() {
		return API_CLIENT(GET_BICYCYLES);
	},

	getNotificationsList() {
		return API_CLIENT(GET_NOTIFICATIONS_LIST);
	},
	getTaxi() {
		return API_CLIENT(GET_TAXI);
	}
};
